import { NXDelete } from "../../icons";
import GenericSelectableTable from "../../components/selectableTable";
import { toast } from "react-toastify";
import RateEditor from "./rateEditor";

import { gql, useMutation } from '@apollo/client';

interface StockTableProps {
    data: any;
    refresh: ()=>void;
}

const DELETE_EXCHANGE_RATE = gql`
  mutation deleteExchangeRate($id: ID!) {
    deleteExchangeRate(id: $id) {
      success
    }
  }
`;

function ExchangeRateTable({data, refresh}:StockTableProps) {
  const [deleteExchangeRate] = useMutation(DELETE_EXCHANGE_RATE);

  const columns = [
    { header: "ID", key: "node.dbId", render:(item:any)=>(
      <div className="text-base-300 text-sm">
        #ID {item.node.dbId}
      </div>
    )},
    { header: "From Currency", key: "node.baseCurrency", },
    { header: "To Currency", key: "node.targetCurrency", },
    { header: "Exchange Rate", key: "node.exchangeRate", render: (item: any) => (

        <RateEditor rate={item.node.exchangeRate} rate_id={item.node.dbId}  />
    )},
    { header: "Actions", key: "actions", render: (item: any) => (
        <div className="flex gap-2">
            <button  onClick={() => handleDelete(item.node.dbId)}  className="p-1">
             <NXDelete  className="text-red-400" />
            </button>
        </div>
    )},

  ]


  const handleDelete = async (id: string) => {
    try {
      const { data } = await deleteExchangeRate({ variables: { id } });
      if (data.deleteExchangeRate.success) {
        toast.success("Exchange rate deleted successfully!");
        refresh(); // Refresh the table after deletion
      } else {
        toast.error("Failed to delete exchange rate.");
      }
    } catch (error) {
      console.error(error);
      toast.error("An error occurred while deleting the exchange rate.");
    }
  };

  
  return (
    <div>
      <div className="overflow-x-auto">
        <GenericSelectableTable columns={columns} data={data}/>
      </div>
    </div>
  )
}

export default ExchangeRateTable